import { z } from 'zod';

import { SafeIdEncoder } from '@fragment/encoded-id/SafeIdEncoder';
import type { SafeString } from '@fragment/types';

export const PaymentsLegalEntityIdEncoder = new SafeIdEncoder().withComponent(
  'id',
  'id'
);

export const PaymentsLegalEntityIdBucketSchema = z
  .string()
  .superRefine((val, ctx) => {
    try {
      PaymentsLegalEntityIdEncoder.decode(val);
    } catch (err) {
      ctx.addIssue({
        code: 'custom',
        message: `PaymentsLegalEntityIdBucketSchema was provided with a malformed string: ${val}`,
      });
    }
  })
  .brand<'PaymentsLegalEntityIdBucket'>();

export type PaymentsLegalEntityIdBucket = z.infer<
  typeof PaymentsLegalEntityIdBucketSchema
>;

export const makePaymentsLegalEntityIdBucket = (
  id: SafeString
): PaymentsLegalEntityIdBucket =>
  PaymentsLegalEntityIdEncoder.encode({ id }) as PaymentsLegalEntityIdBucket;

type DecomposedPaymentsLegalEntityIdBucket = {
  id: SafeString;
};

export const decomposePaymentsLegalEntityIdBucket = (
  bucket: PaymentsLegalEntityIdBucket
): DecomposedPaymentsLegalEntityIdBucket => {
  const { id } = PaymentsLegalEntityIdEncoder.decode(bucket);
  return { id };
};
